import { Link } from 'react-router-dom';

import './PageNotFound.css';

function PageNotFound() {
  return (
    <section className="not-found">
      <div className="wrap">
        <h1 className="not-found__title h2">Oops, page not found</h1>
        <Link className="btn btn--dark" to="/">
          Go to homepage
        </Link>
      </div>
    </section>
  );
}

export default PageNotFound;
